import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import './index.scss';
import App from './App';
import Login from './pages/auth/Login';
import Logout from './pages/auth/Logout';
import reportWebVitals from './reportWebVitals';
import { initializeIcons } from '@fluentui/react/lib/Icons';
import { MsalProvider } from "@azure/msal-react";
import Auth from './Auth';

initializeIcons(/* optional base url */);
ReactDOM.render(
    <React.StrictMode>
        {/* Provides a context containing an instance of PublicClientApplication used for auth */}
        <MsalProvider instance={Auth.app}>
            <BrowserRouter>
                <Switch>
                    <Route path="/login" exact component={Login} />
                    <Route path="/logout" exact component={Logout} />
                    <Route path="/" component={App} />
                </Switch>
            </BrowserRouter>
        </MsalProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
